import { useGuestLikedProducts } from './useGuestLikedProducts';

export function useIsGuestLiked(productId: number) {
  const guestLikes = useGuestLikedProducts();
  return guestLikes.some(({ id }) => id === productId);
}
